// Vendor
import { register } from 'register-service-worker';

// Personal libs
import { dbAddState } from '@data/datasource/local/service-worker.database';
import { ServiceWorkerStatusEnum } from '@shared/enum/service-worker.enum';
import { swLogger } from '@shared/lib/logger/logger-manager';

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready(/* registration */) {
    swLogger?.log('[Service Worker] Service worker is active.');

    dbAddState({
      status: ServiceWorkerStatusEnum.READY,
      version: process.env.FRONTEND.currentVersion,
    });
  },

  registered(registration) {
    swLogger?.log('[Service Worker] Service worker has been registered.');

    dbAddState({
      status: ServiceWorkerStatusEnum.REGISTERED,
      version: process.env.FRONTEND.currentVersion,
    });

    // Force update of service worker
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },

  cached(/* registration */) {
    swLogger?.log('[Service Worker] Content has been cached for offline use.');

    dbAddState({
      status: ServiceWorkerStatusEnum.CACHED,
      version: process.env.FRONTEND.currentVersion,
    });
  },

  updatefound(/* registration */) {
    swLogger?.log('[Service Worker] New content is downloading.');

    dbAddState({
      status: ServiceWorkerStatusEnum.UPDATE_FOUND,
      version: process.env.FRONTEND.currentVersion,
    });
  },

  updated(registration) {
    swLogger?.log('[Service Worker] New content is available; please refresh.');

    dbAddState({
      status: ServiceWorkerStatusEnum.UPDATED,
      version: process.env.FRONTEND.currentVersion,
    });

    // Force update of service worker
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      swLogger?.log('[Service Worker] Force SKIP_WAITING');
    }
  },

  offline() {
    swLogger?.log(
      '[Service Worker] No internet connection found. App is running in offline mode.'
    );

    dbAddState({
      status: ServiceWorkerStatusEnum.OFFLINE,
      version: process.env.FRONTEND.currentVersion,
    });
  },

  error(err) {
    swLogger?.error(
      '[Service Worker] Error during service worker registration:',
      err
    );

    dbAddState({
      status: ServiceWorkerStatusEnum.ERROR,
      version: process.env.FRONTEND.currentVersion,
    });
  },
});
